import { ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Navbar";

const PRODUCT = [
  { label: "Features", to: "/#features" },
  { label: "Live Demo", to: "/#demo" },
  { label: "Pricing", to: "/#pricing" },
  { label: "Airdrop", to: "/airdrop" },
  { label: "USDC Mining", to: "/mining" },
];

const RESOURCES = [
  { label: "Website", href: "https://bnwpay.com", testid: "footer-link-website" },
  { label: "Whitepaper", href: "/BnW-Pay-Whitepaper.pdf", testid: "footer-link-whitepaper", external: true },
  { label: "X (Twitter)", href: "https://x.com/bnwpay", testid: "footer-link-x" },
  { label: "Telegram", href: "https://t.me/bnwpayofficial", testid: "footer-link-telegram" },
  { label: "Medium", href: "https://medium.com/@bnwpay", testid: "footer-link-medium" },
  { label: "Contact", href: "mailto:hello@bnwpay.com", testid: "footer-link-contact" },
];

export default function Footer() {
  const navigate = useNavigate();
  const go = (to) => {
    if (to.startsWith("/#")) {
      const id = to.slice(2);
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 120);
    } else {
      navigate(to);
    }
  };

  return (
    <footer className="border-t border-line bg-panel" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-12">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo className="h-10 w-28" testid="footer-logo" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-mut">
              The non-custodial stablecoin payment gateway for small merchants. Built on Solana.
            </p>
            <p
              className="mt-6 max-w-sm rounded-xl border border-line bg-card2 p-4 text-xs leading-relaxed text-mut"
              data-testid="footer-disclaimer"
            >
              B&W Pay is a non-custodial tool. We do not hold, transmit, or control user funds.
            </p>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-mut">Product</p>
            <ul className="mt-5 space-y-3">
              {PRODUCT.map((l) => (
                <li key={l.label}>
                  <button
                    onClick={() => go(l.to)}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-white/85 transition-colors hover:text-sgreen"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-mut">Resources</p>
            <ul className="mt-5 space-y-3">
              {RESOURCES.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    target={l.href.startsWith("mailto") ? undefined : "_blank"}
                    rel="noopener noreferrer"
                    data-testid={l.testid}
                    className="group inline-flex items-center gap-1.5 text-sm text-white/85 transition-colors hover:text-sgreen"
                  >
                    {l.label}
                    <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity group-hover:opacity-100" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-line pt-8 sm:flex-row sm:items-center">
          <p className="font-mono text-xs text-mut">© 2026 B&W Pay. All rights reserved.</p>
          <p className="flex items-center gap-2 font-mono text-xs text-mut">
            <span className="h-1.5 w-1.5 rounded-full bg-sgreen" />
            Runs on Solana
          </p>
        </div>
      </div>
    </footer>
  );
}
